import ArchievedList from '../../components/deal/archieved_list';
import AutomationBuilderComponent from '../../components/automation/builder';
import AutomationComponent from '../../components/automation';
import CardWrapper from '../../components/wrapper/card';
import DealDetails from '../../components/deal/detail';
import EditDeal from '../../components/deal/edit';
import EmailAndSMSComponent from '../../components/deal/email_and_sms';
import PipelineComponent from '../../components/pipeline';
import ProspectComponent from '../../components/prospecting';
import React from 'react';
import { settingSelectedDealTab } from '../../redux/slices/deal';
import { settingSelectedPipeline } from '../../redux/slices/pipeline';
import { AppDispatch, RootState } from '../../redux/store';
import { Box, Divider, Tab, Tabs } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';

interface CustomTabPanelProps {
    children?: React.ReactNode;
    index: number;
    value: unknown;
}

export const CustomTabPanel = ({ children, value, index }: CustomTabPanelProps) => (
    <Box
        role="tabpanel"
        hidden={value !== index}
        id={`simple-tabpanel-${index}`}
        aria-labelledby={`simple-tab-${index}`}
        width="100%"
    >
        {value === index && <Box>{children}</Box>}
    </Box>
);

export const a11yProps = (index: number) => ({
    'id': `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`
});

const DealsPage = () => {
    const dispatch = useDispatch<AppDispatch>();
    const { flags: DealFlags } = useSelector((state: RootState) => state.deal);
    const { selectedTab } = useSelector((state: RootState) => state.deal);
    const { flags: AutomationFLags, selectedAutomation } = useSelector((state: RootState) => state.automation);
    const handleChange = (event: React.SyntheticEvent, newValue: 0 | 1 | 2) => {
        dispatch(settingSelectedPipeline(null));
        dispatch(settingSelectedDealTab(newValue));
    };

    if (DealFlags.showEmailAndSMS !== null) {
        return <Box pb="100px"><EmailAndSMSComponent /></Box>;
    } else if (DealFlags.viewDetail && !DealFlags.editDeal) {
        return <Box pb="100px"><DealDetails /></Box>;
    } else if (DealFlags.editDeal) {
        return <Box pb="100px"><EditDeal /></Box>;
    } else if (AutomationFLags.showBuilder && selectedAutomation) {
        return <Box pb="100px"><AutomationBuilderComponent /></Box>;
    }

    return (
        <Box padding="15px" minHeight="80vh" overflow="auto" pb="100px">
            <CardWrapper>
                <Tabs
                    value={selectedTab}
                    onChange={handleChange}
                    aria-label="deal auto prospects"
                >
                    <Tab
                        label="Prospecting"
                        {...a11yProps(0)}
                    />
                    <Tab
                        label="Pipeline"
                        {...a11yProps(1)}
                    />
                    <Tab
                        label="Automation"
                        {...a11yProps(2)}
                    />
                </Tabs>
                <Divider />
                <CustomTabPanel value={selectedTab} index={0}>
                    <ProspectComponent />
                </CustomTabPanel>

                <CustomTabPanel value={selectedTab} index={1}>
                    {DealFlags.showArchievedList ? <ArchievedList /> : <PipelineComponent />}
                </CustomTabPanel>

                <CustomTabPanel value={selectedTab} index={2}>
                    <AutomationComponent />
                </CustomTabPanel>
            </CardWrapper>
        </Box>
    );
};
export default DealsPage;